// eslint-disable-next-line
import { action, makeObservable, observable, runInAction } from "mobx";
import { rootContainer, TYPE } from "../../../services/container/root";
import type { ICredit } from "../../../services/api/credits-service";
import CreditsService from "../../../services/api/credits-service";
import PagedDataStore, { IFetchListArgs, IPagedData } from "../../../stores/abstract-paged-data-store";
import CreditSrore from "./credit-store";

class CreditsPagedListStore extends PagedDataStore<CreditSrore> {
	@observable private _search_customer_id: string = '';
	@observable private _creditToAdjust?: ICredit;
	@observable private _isProcessing: boolean = false;

	constructor() {
		super();
		makeObservable(this);
	}

	@action
	public setSearchCustomerId(value: string) {
		this._search_customer_id = value;
	}

	public get searchCustomerId() {
		return this._search_customer_id;
	}

	protected get service(): CreditsService {
		return rootContainer.get<CreditsService>(TYPE.CreditsService);
	}

	protected async fetchList(args: IFetchListArgs) {
		let result: IPagedData<ICredit>|undefined = undefined;

		try {
			result = await this.service.fetchList({ ...args, search_customer_id: this._search_customer_id });
		}
		catch {}

		if (result) {
			return {
				...result,
				data: result.data.map(credit => {
					const store = new CreditSrore();
					store.setModel(credit);
					return store;
				})
			};
		}
		return undefined;
	}

	@action
	public setCreditToAdjust(value: ICredit | undefined) {
		this._creditToAdjust = value;
	}

	public get creditToAdjust(): ICredit | undefined {
		return this._creditToAdjust
	}

	@action
	public async adjustBalance(amount: number, transaction_type_id: number, comment: string) {
		if (!this._creditToAdjust) {
			return;
		}
		this._isProcessing = true;
		let updatedCredit: ICredit;

		try {
			updatedCredit = await this.service.adjustBalance(this._creditToAdjust.id, transaction_type_id, amount, comment);
		}
		catch {}

		runInAction(() => {
			this._isProcessing = false;
			if (updatedCredit) {
				this._list.find(i => i.id === updatedCredit.id)?.setModel(updatedCredit);
			}
			this._creditToAdjust = undefined;
		});
	}

	public get isProcessing(): boolean {
        return this._isProcessing;
    }
}

export default new CreditsPagedListStore();
